export function ConvertToGrams(weight, unit){
    let grams = 0.0;
    switch (unit) {
        case 'kg':
            grams = weight * 1000; // 1 kilogram = 1000 grams
            break;
        case 'oz':
            grams = weight * 28.3495; // 1 ounce = 28.3495 grams
            break;
        case 'lb':
            grams = weight * 453.592; // 1 pound = 453.592 grams
            break;
        case 'g':
            grams = weight; // already in grams
            break;
        default:
            grams = weight; // in case of unknown unit, return the input
            break;
    }
    return parseFloat(grams).toFixed(2);
}